import { MenuProps } from 'antd';
import React from 'react';

import Bills from 'assets/icons/Bills.svg?react';
import ElectricMeter from 'assets/icons/ElectricMeter.svg?react';
import PhoneFilled from 'assets/icons/PhoneFilled.svg?react';
import Request from 'assets/icons/Request.svg?react';
import ThunderboltFilled from 'assets/icons/ThunderboltFilled.svg?react';

type MenuItem = Required<MenuProps>['items'][number];

const menuItems: MenuItem[] = [
  { key: '/', label: 'Factures', icon: <Bills /> },
  {
    key: '/consommations',
    label: 'Consommations',
    icon: <ThunderboltFilled />,
  },
  { key: '/compteurs', label: 'Compteurs', icon: <ElectricMeter /> },
  { key: '/demandes', label: 'Demandes', icon: <Request /> },
  { key: '/contact', label: 'Contact', icon: <PhoneFilled /> },
];

export default menuItems;
